/**
 * @fileoverview gRPC-Web generated client stub for auth
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: auth/auth.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.auth = require('./auth_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.auth.AuthClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.auth.AuthPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.EmailPassword,
 *   !proto.auth.BearerToken>}
 */
const methodDescriptor_Auth_UsingPassword = new grpc.web.MethodDescriptor(
  '/auth.Auth/UsingPassword',
  grpc.web.MethodType.UNARY,
  proto.auth.EmailPassword,
  proto.auth.BearerToken,
  /**
   * @param {!proto.auth.EmailPassword} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.auth.BearerToken.deserializeBinary
);


/**
 * @param {!proto.auth.EmailPassword} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.auth.BearerToken)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.auth.BearerToken>|undefined}
 *     The XHR Node Readable Stream
 */
proto.auth.AuthClient.prototype.usingPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/auth.Auth/UsingPassword',
      request,
      metadata || {},
      methodDescriptor_Auth_UsingPassword,
      callback);
};


/**
 * @param {!proto.auth.EmailPassword} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.auth.BearerToken>}
 *     Promise that resolves to the response
 */
proto.auth.AuthPromiseClient.prototype.usingPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/auth.Auth/UsingPassword',
      request,
      metadata || {},
      methodDescriptor_Auth_UsingPassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.UsingTokenRequest,
 *   !proto.auth.BearerToken>}
 */
const methodDescriptor_Auth_UsingToken = new grpc.web.MethodDescriptor(
  '/auth.Auth/UsingToken',
  grpc.web.MethodType.UNARY,
  proto.auth.UsingTokenRequest,
  proto.auth.BearerToken,
  /**
   * @param {!proto.auth.UsingTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.auth.BearerToken.deserializeBinary
);


/**
 * @param {!proto.auth.UsingTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.auth.BearerToken)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.auth.BearerToken>|undefined}
 *     The XHR Node Readable Stream
 */
proto.auth.AuthClient.prototype.usingToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/auth.Auth/UsingToken',
      request,
      metadata || {},
      methodDescriptor_Auth_UsingToken,
      callback);
};


/**
 * @param {!proto.auth.UsingTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.auth.BearerToken>}
 *     Promise that resolves to the response
 */
proto.auth.AuthPromiseClient.prototype.usingToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/auth.Auth/UsingToken',
      request,
      metadata || {},
      methodDescriptor_Auth_UsingToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.EmailPassword,
 *   !proto.auth.BearerToken>}
 */
const methodDescriptor_Auth_ContentUpdateToken = new grpc.web.MethodDescriptor(
  '/auth.Auth/ContentUpdateToken',
  grpc.web.MethodType.UNARY,
  proto.auth.EmailPassword,
  proto.auth.BearerToken,
  /**
   * @param {!proto.auth.EmailPassword} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.auth.BearerToken.deserializeBinary
);


/**
 * @param {!proto.auth.EmailPassword} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.auth.BearerToken)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.auth.BearerToken>|undefined}
 *     The XHR Node Readable Stream
 */
proto.auth.AuthClient.prototype.contentUpdateToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/auth.Auth/ContentUpdateToken',
      request,
      metadata || {},
      methodDescriptor_Auth_ContentUpdateToken,
      callback);
};


/**
 * @param {!proto.auth.EmailPassword} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.auth.BearerToken>}
 *     Promise that resolves to the response
 */
proto.auth.AuthPromiseClient.prototype.contentUpdateToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/auth.Auth/ContentUpdateToken',
      request,
      metadata || {},
      methodDescriptor_Auth_ContentUpdateToken);
};


module.exports = proto.auth;

